import { API_BASE_URL } from './api.js';
import {
  overviewResponseSchema,
  serializeOverviewCardPrefs,
  type OverviewCardId,
  type OverviewCardPrefs,
  type OverviewResponse,
} from '@reos/today-metrics';

/**
 * Krok GRAF2 — klient souhrnu obrazovky „Přehled".
 *
 * Tvar odpovedi NENI psany rucne: `overviewResponseSchema` je tytez schema,
 * jakym endpoint `GET /v1/overview` svou odpoved validuje (SSOT v
 * `@reos/today-metrics`). Rucni atrapa DTO by tise zestarla pri prvni nove
 * karte — presne to, co CLAUDE.md §8 pravidlo 2 zakazuje.
 */

export const OVERVIEW_QUERY_KEY = ['overview'] as const;

export type { OverviewCardId, OverviewCardPrefs, OverviewResponse };

export async function fetchOverview(): Promise<OverviewResponse> {
  const res = await fetch(`${API_BASE_URL}/v1/overview`, {
    credentials: 'include',
    headers: { accept: 'application/json' },
  });
  if (!res.ok) throw new Error(`overview:${String(res.status)}`);
  /*
   * Odpoved se PARSUJE, ne jen pretypuje: starsi nasazeni serveru (bez
   * nektere karty) nebo zmena tvaru by jinak skoncila vyjimkou az uvnitr
   * sazby karty, kde uz nejde rict, co se pokazilo.
   */
  return overviewResponseSchema.parse(await res.json());
}

/**
 * Ulozi rozvrzeni karet k uzivateli (plati na vsech zarizenich). Jde TOUTEZ
 * cestou jako vzhled a velikost pisma — `PATCH /api/me/ui-preferences`,
 * zadny druhy endpoint pro predvolby.
 *
 * `false` = neulozilo se. Volba uz je na obrazovce videt, takze selhani
 * serveru nesmi shodit obrazovku (tataz uvaha jako u `saveUiPreferences`).
 */
export async function saveOverviewCards(prefs: OverviewCardPrefs): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE_URL}/api/me/ui-preferences`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      // Pres serializaci a zpet: zahodi neznamou kartu drive, nez ji server
      // odmitne jako 400 (tataz funkce, jakou cte server ulozenou hodnotu).
      body: JSON.stringify({ overviewCards: JSON.parse(serializeOverviewCardPrefs(prefs)) }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
